const colorMap = new Map([
  ["Black", "#000000"],
  ["Tan", "#D2B48C"],
  ["Brown", "#a52a2a"],
  ["White", "#ffffff"],
  ["Pink", "#ffc0cb"],
  ["Copper", "#b87333"],
  ["Blue", "#0074d9"],
  ["Maroon", "#800000"],
  ["Purple", "#800080"],
  ["Olive Green", "#3c341f"],
  ["Red", "#f80004"],
  ["Grey", "#808080"],
  ["Golden", "#d4af37"],
  ["Beige", "#F5F5DC"],
  ["Peach", "#ffe5b4"],
  ["Navy Blue", "#000080"],
  ["Cream", "#FFFDD0"],
  ["Green", "#008000"],
  ["Silver", "#c0c0c0"],
  ["Yellow", "#ffef2e"],
  ["Orange", "#ffa600"],
  ["Sky Blue", "#87CEEB"],
  ["Cherry", "#B62625"],
  ["Voilet", "#8F00FF"],
  ["Sea Blue", "#006994"],
  ["Lemon", "#fff700"],
]);

var addCollectionSorting = (filter) => {
  let isJson = false,
    isSortJson = false;
  typeof filter == "string" && ((isJson = true), (filter = JSON.parse(filter))),
    typeof filter.sort == "string" &&
      ((isSortJson = true), (filter.sort = JSON.parse(filter.sort)));
  let newSort = [];
  if (filter.sort[0].field === "product_wizzy-best-selling_sortOrder:float") {
    newSort = filter.sort.filter(
      (item) => item.field !== "product_wizzy-best-selling_sortOrder:float"
    );
  } else {
    newSort = filter.sort;
  }
  console.log(newSort);

  (filter.sort = newSort),
    isSortJson && (filter.sort = JSON.stringify(filter.sort)),
    isJson && (filter = JSON.stringify(filter));
};

function createViewMoreBtn(itemsToShowCount, element, facetItems, viewMoreBtn) {
  viewMoreBtn.style.display = "flex";

  const initialItemsToShow = itemsToShowCount;
  let itemsToShow = initialItemsToShow;

  // Function to update the visibility of list items
  const updateVisibility = () => {
    facetItems.forEach((item, index) => {
      // console.log(index)
      if (index >= itemsToShow) {
        item.classList.add("visible");
      } else {
        item.classList.remove("visible");
      }
    });
  };
  // Initially show only the first 5 items
  updateVisibility();

  viewMoreBtn.addEventListener("click", () => {
    itemsToShow += initialItemsToShow;
    updateVisibility();
    // Show the View Less button when more items are shown
    // viewLessBtn.style.display = "inline";
    // Hide the View More button if all items are visible
    if (itemsToShow >= facetItems.length) {
      viewMoreBtn.style.display = "none";
    }
  });
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // console.log("==================inside",data);
      data.common.lazyDOMConfig.searchInputIdentifiers[0].dom = "header input";
      data.common.lazyDOMConfig.searchInputIdentifiers[0].type = "text";

      /*for grid filters - starts here*/
      data["search"]["view"]["templates"]["facets"]["gridFilterCommon"] =
        "#wizzy-grid-facet-block";
      data["gridFilters"] = {
        enabled: true,
        filters: [
          { key: "sizes", question: "Filter for Size", after: { mobile: 6 } },
        ],
      };
      /*for grid filters - ends here*/
      data.filters.configs.keepOpenedInMobileAfterApply = true;

      (window.wizzyConfig.search.view.templates.facets.rangeListItem =
        "#wizzy-facet-range-list-item"),
        window.wizzyConfig.search.configs.facets.configs.push({
          label: "Price",
          buckets: [
            {
              from: 0,
              to: 500,
            },
            {
              from: 500,
              to: 1000,
            },
            {
              from: 1000,
              to: 2500,
            },
            {
              from: 2500,
              to: 5000,
            },
            {
              from: 5000,
              to: 10000,
            },
            {
              from: 10000,
            },
          ],
          key: "sellingPrice",
          position: "left",
          order: 6,
        });
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log("VIEW_RENDERED");

      $(".heading-txt")
        .off("click")
        .on("click", function () {
          $(this).toggleClass("active");
          $(this).parent().find(".descp-txt").slideToggle(280);
        });

      /*code for activated link on collection page - starts here*/
      var links = document.querySelectorAll(".clp-catg-tile a");
      // Get the current URL
      var currentURL = window.location.href;
      // Iterate over each anchor tag
      links.forEach(function (link) {
        // Check if the href attribute matches the current URL
        if (link.href === currentURL) {
          // Add the active class to the anchor tag
          link.classList.add("active");
        }
      });
      /*code for activated link on collection page - ends here*/

      /*show no of count for applied filters - starts here*/
      var activeFilterCount1 = 0;
      $(".wizzy-filters-facet-block").each((index, element) => {
        $(element)
          .find(".wizzy-facet-body .wizzy-facet-list .active")
          .each((i, ele) => {
            // console.log(ele);
            activeFilterCount1++;
          });
      });
      activeFilterCount1 > 0 &&
        $(".wizzy-filters-mobile-entry .wizzy-filter-mobile-count b").html(
          activeFilterCount1
        );
      /*show no of count for applied filters - ends here*/

      /*total number of count of collection products - starts here*/
      if (window.wizzyConfig.common.isOnCategoryPage) {
        const collectionHeader = document.querySelector(
          ".page_collection_heading .t4s-page-section-heading .t4s-page-head .t4s-title-head .wizzy-collection-count"
        );
        if (data.data.response.payload.filters.type === "NO_RESULTS_FOUND") {
          collectionHeader.textContent = 0 + " Choices";
        } else {
          collectionHeader.textContent =
            data.data.response.payload.total + " Choices";
        }
      }
      /*total number of count of collection products - ends here*/

      data.data.response.payload.facets.forEach((facet) => {
        /*view more button - starts here*/
        if (
          facet.data.length > 5 &&
          facet.key !== "sizes" &&
          facet.key != "product_Color"
        ) {
          const element = document.querySelector(
            '[data-key="' + facet.key + '"]'
          );
          const facetItems = element.querySelectorAll(
            ".wizzy-facet-body .wizzy-facet-list li"
          );
          const viewMoreBtn = element.querySelector(".wizzy-view-more-btn");

          createViewMoreBtn(5, element, facetItems, viewMoreBtn);
        } else {
          if (facet.data.length > 12) {
            const element = document.querySelector(
              '[data-key="' + facet.key + '"]'
            );
            const facetItems = element.querySelectorAll(
              ".wizzy-facet-body .wizzy-facet-list li"
            );
            const viewMoreBtn = element.querySelector(".wizzy-view-more-btn");

            createViewMoreBtn(12, element, facetItems, viewMoreBtn);
          }
        }
      });
      /*view more button - ends here*/

      setTimeout(function () {
        const swiperContainers = document.querySelectorAll(".mySwiper");
        // console.log(swiperContainers);
        swiperContainers.forEach((container) => {
          let swiperInstance = null;

          container.addEventListener("mouseover", () => {
            if (!swiperInstance) {
              swiperInstance = new Swiper(container, {
                loop: true,
                speed: 600,
                autoplay: {
                  delay: 100,
                  disableOnInteraction: false,
                },
              });
            } else {
              swiperInstance.autoplay.start();
            }
          });

          container.addEventListener("mouseleave", () => {
            if (swiperInstance) {
              swiperInstance.autoplay.stop();
              swiperInstance.slideTo(0, 1000);
            }
          });
        });
      }, 300);

      return data;
    }
  );

  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED,
  //    function (data) {

  //      const swiperContainers = document.querySelectorAll('.mySwiper');
  //      console.log(swiperContainers)
  //      swiperContainers.forEach(container => {

  //        let swiperInstance = null;

  //        container.addEventListener('mouseover', () => {
  //          console.log("mouseover")
  //          if (!swiperInstance) {
  //            swiperInstance = new Swiper(container, {
  //              loop: true,
  //              speed: 600,
  //              autoplay: {
  //                delay: 100,
  //                disableOnInteraction: false,
  //              },
  //            });
  //          } else {
  //            swiperInstance.autoplay.start();
  //          }
  //        });

  //        container.addEventListener('mouseleave', () => {
  //          if (swiperInstance) {
  //            swiperInstance.autoplay.stop();
  //            swiperInstance.slideTo(0,1000);
  //          }
  //        });
  //      });

  //      return data;
  //    })

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      /*for swiper on image 404 page - starts here*/
      // const swiperContainers = document.querySelectorAll('.mySwiper');
      // swiperContainers.forEach(container => {

      //   let swiperInstance = null;

      //   container.addEventListener('mouseover', () => {
      //     console.log("mouseover")
      //     if (!swiperInstance) {
      //       swiperInstance = new Swiper(container, {
      //         loop: true,
      //         speed: 600,
      //         autoplay: {
      //           delay: 100,
      //           disableOnInteraction: false,
      //         },
      //       });
      //     } else {
      //       swiperInstance.autoplay.start();
      //     }
      //   });

      //   container.addEventListener('mouseleave', () => {
      //     if (swiperInstance) {
      //       swiperInstance.autoplay.stop();
      //       swiperInstance.slideTo(0,1000);
      //     }
      //   });
      // });
      /*for swiper on image 404 page - ends here*/

      data.forEach((product) => {
        if (product.url) {
          const questionMarkIndex = product.url.indexOf("?");
          product.url =
            questionMarkIndex !== -1
              ? product.url.slice(0, questionMarkIndex)
              : product.url;
        }

        product.attributes.forEach((attr) => {
          if (attr.id === "product_badge_judgeme") {
            product.badge_judgeme = attr.values[0].value[0];
            const htmlString = attr.values[0].value[0];

            // Create a temporary element
            const tempElement = document.createElement("div");

            // Set innerHTML of the temporary element to the provided string
            tempElement.innerHTML = htmlString;

            // Get the element with the class name jdgm-prev-badge__stars
            const element = tempElement.querySelector(".jdgm-prev-badge");
            const reviewTag = tempElement
              .querySelector(".jdgm-prev-badge")
              .querySelector(".jdgm-prev-badge__text");
            //getting totalRatings and totalReviews
            const dataScore = parseFloat(
              element.getAttribute("data-average-rating")
            ).toFixed(1);

            const dataReview = element.getAttribute("data-number-of-reviews");
            reviewTag.innerHTML = dataScore;
            // product.reviewHTML = element.innerHTML;
            //console.log(element.innerHTML);
            //tempElement = tempElement.toString();
            if (dataReview == 0) {
              product.reviewHTML = null;
            } else {
              product.reviewHTML = element.innerHTML;
            }
          }
          if (attr.id === "product_tags") {
            product.newArrival =
              attr.values[0].value[0].includes("New Arrivals");
          }
        });

        product.sellingPrice = product.sellingPrice.split(".")[0];
        product.price = product.price.split(".")[0];
      });

      data.forEach((product) => {
        product.newArrival = false;
        product.newDrops = false;
        product.trendings = false;
        product.crazyDeals = false;
        if (product.attributes) {
          product.attributes.forEach((attribute) => {
            if (attribute.id === "product_tags") {
              if (attribute.values[0].value[0].length > 0) {
                // if(attribute.values[0].value[0].includes("New Arrivals")) {
                //   product.newArrival = true;
                // }
                // if(attribute.values[0].value[0].includes("new_drops") && !product.newArrival) {
                //   product.newDrops = true;
                // }
                // if(attribute.values[0].value[0].includes("Trending") && !product.newArrival && !product.newDrops) {
                //   product.trendings = true;
                // }
                // if(attribute.values[0].value[0].includes("crazy_deal") && !product.newArrival && !product.newDrops && !product.trendings) {
                //   product.crazyDeals = true;
                // }

                if (attribute.values[0].value[0].includes("crazy_deal")) {
                  product.crazyDeals = true;
                }
                if (
                  attribute.values[0].value[0].includes("Trending") &&
                  !product.crazyDeals
                ) {
                  product.trendings = true;
                }
                if (
                  attribute.values[0].value[0].includes("new_drops") &&
                  !product.crazyDeals &&
                  !product.trendings
                ) {
                  product.newDrops = true;
                }
                if (
                  attribute.values[0].value[0].includes("New Arrivals") &&
                  !product.crazyDeals &&
                  !product.trendings &&
                  !product.newDrops
                ) {
                  product.newArrival = true;
                }
              }
            }
          });
        }
      });

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log("=====>BEFORE_AUTOCOMPLETE_EXECUTED",payload);

      payload.sort = [
        {
          field: "product_value_tags_gender",
          order: "asc",
        },
      ];

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log("===>BEFORE_SEARCH_EXECUTED",payload);

      payload.sort.push({
        field: "product_value_tags_gender",
        order: "asc",
      });

      // payload.sort = [{
      //   "field" : "product_value_tags_gender",
      //   "order" : "asc"
      // }]

      const collectionHeading = document.querySelector(
        ".page_collection_heading"
      );
      if (collectionHeading) {
        // console.log(collectionHeading)
        collectionHeading.classList.add("wizzy-hide-collection-heading");
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log("===========>BEFORE_FILTERS_EXECUTED",payload)

      if (!wizzyConfig.common.isOnCategoryPage) {
        payload.filters.sort.push({
          field: "product_value_tags_gender",
          order: "asc",
        });
      }
      if (wizzyConfig.common.isOnCategoryPage) {
        addCollectionSorting(payload.filters);
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        // console.log(facets)
        /*eleminate facet for single option in gender filter - starts here*/
        // let facets = data.data.response.payload.facets;
        var index = -1;
        for (var i = 0; i < facets.length; i++) {
          if (
            facets[i].key === "product_value_tags_gender" &&
            facets[i].data.length == 1
          ) {
            var index = i;
            break;
          }
        }
        if (index !== -1) {
          payload.response.payload.facets.splice(index, 1);
        }
        /*eleminate facet for single option in gender filter - ends here*/

        facets.forEach((facet) => {
          if (facet.key === "sizes") {
            facet.data.sort((a, b) => {
              return parseInt(a.key) - parseInt(b.key);
            });
            facet.order = 0;
          }
          if (facet.key === "product_Color") {
            facet.data.forEach((item) => {
              (item.isSwatch = !0),
                (item.isVisualSwatch = !0),
                (item.swatchValue = colorMap.has(item.key)
                  ? colorMap.get(item.key)
                  : "#fff"),
                (item.data = {
                  value: colorMap.get(item.key),
                  swatch: {
                    type: "visual",
                    value: colorMap.get(item.key),
                  },
                });
            });
          }
          /*eleminate facet data with 0 count in price filter - starts here*/
          if (facet.key === "sellingPrice") {
            var priceFacetData = facet.data;

            for (var i = priceFacetData.length - 1; i >= 0; i--) {
              if (priceFacetData[i].count == 0) {
                facet.data.splice(i, 1);
              }
            }
          }
          /*eleminate facet data with 0 count in price filter - ends here*/
        });
      }
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      const wizzyData = JSON.parse(sessionStorage.getItem("wizzy_store"));

      if (window.wizzyConfig.common.isOnCategoryPage) {
        const collectionHeader = document.querySelector(
          ".page_collection_heading .t4s-page-section-heading .t4s-page-head .t4s-title-head .wizzy-collection-count"
        );
        collectionHeader.textContent =
          wizzyData.SEARCH_CACHE.cached.searchedResponse.total + " Choices";
        // localStorage.set("collection-count",data.data.response.payload.total);
      }

      // console.log(wizzyData.SEARCH_CACHE.cached.searchedResponse.total);

      const swiperContainers = document.querySelectorAll(".mySwiper");
      swiperContainers.forEach((container) => {
        let swiperInstance = null;

        container.addEventListener("mouseover", () => {
          if (!swiperInstance) {
            swiperInstance = new Swiper(container, {
              loop: true,
              speed: 600,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
              },
            });
          } else {
            swiperInstance.autoplay.start();
          }
        });

        container.addEventListener("mouseleave", () => {
          if (swiperInstance) {
            swiperInstance.autoplay.stop();
            swiperInstance.slideTo(0, 1000);
          }
        });
      });

      // const allImageContainer = document.querySelectorAll(".t4s-product-img");
      //  allImageContainer.forEach((imageContainer) => {
      //    const image1 = imageContainer.querySelector(".t4s-product-main-img");
      //    const image2 = imageContainer.querySelector(".t4s-product-hover-img");
      //    imageContainer.addEventListener("mouseenter", () => {
      //      image1.style.transform = "translateX(-100%)";
      //      image2.style.transform = "translateX(0)";
      //    });
      //    imageContainer.addEventListener("mouseleave", () => {
      //      image1.style.transform = "translateX(0)";
      //   image2.style.transform = "translateX(100%)";
      //    });
      //  });
      return payload;
    }
  );

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-wrapper");
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-facet-block");
  changeTemplate("wizzy-search-empty-results");
};

const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};

window.addEventListener("popstate", function (event) {
  if (
    window.location.href.startsWith(
      "https://libertyshoes-online.myshopify.com/collections"
    )
  ) {
    const collectionHeading = document.querySelector(
      ".page_collection_heading"
    );
    collectionHeading.classList.remove("wizzy-hide-collection-heading");
  }

  const allImageContainer = document.querySelectorAll(".t4s-product-img");
  // console.log(allImageContainer)
  allImageContainer.forEach((imageContainer) => {
    const image1 = imageContainer.querySelector(".t4s-product-main-img");
    const image2 = imageContainer.querySelector(".t4s-product-hover-img");
    imageContainer.addEventListener("mouseenter", () => {
      image1.style.transform = "translateX(-100%)";
      image2.style.transform = "translateX(0)";
    });
    imageContainer.addEventListener("mouseleave", () => {
      image1.style.transform = "translateX(0)";
      image2.style.transform = "translateX(100%)";
    });
  });
});

window.addEventListener("scroll", function () {
  const navbar = document.querySelector("header#shopify-section-header-inline");
  const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
  const navbarTop = navbar.getBoundingClientRect().bottom;

  autocomplete.style.setProperty("top", `${navbarTop}px`, "important");
});

window.addEventListener("click", function () {
  const navbar = document.querySelector("header#shopify-section-header-inline");
  const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
  const navbarTop = navbar.getBoundingClientRect().bottom;

  autocomplete.style.setProperty("top", `${navbarTop}px`, "important");
});

// });
